import React, { useEffect, useState } from 'react'
import StudentSidebar from '../StudentSidebar/StudentSidebar'
import { getStudentMyBookingsList } from '../../../Redux/action/StudentAction';
import { useDispatch, useSelector } from 'react-redux';
import Beatloader from '../../../Common/BeatLoader';
import { Link } from 'react-router-dom';
import ResponsivePagination from '../../../Common/Pagination';

const StudentBooking = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getStudentMyBookingsList())
    }, []);

    const {
        loadingMyBookingsListApi,
        MyBookingsListApiData,
        MyBookingsListApiError


    } = useSelector(state => state?.StudentReducer);

    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const dataPerPage = 10;


    useEffect(() => {
        if (!MyBookingsListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(MyBookingsListApiData.slice(start, end));
        setPageCount(Math.ceil(MyBookingsListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, MyBookingsListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };


    return (
        <div className='pagination-component'>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Bookings
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="bookings-sec">
                                    <h4 className="mb-3">Booking Summary</h4>
                                    {loadingMyBookingsListApi ?
                                        <Beatloader />
                                        : <div className="table-responsive">
                                            <table className="table table-light">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">S.No.</th>
                                                        <th scope="col">Tutor lists</th>
                                                        <th scope="col">Schedule Date</th>
                                                        <th scope="col">Schedule Timing</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {MyBookingsListApiData?.length > 0 ?
                                                        currentData?.map((data, index) => (
                                                            <tr key={data?.booking_id}>
                                                                <th>{index + 1}</th>
                                                                <td>
                                                                    <div>
                                                                        {/* <span className="table-img">
                                                                            <img
                                                                                src="/assets/img/user/user1.jpg"
                                                                                className="img-fluid"
                                                                            />
                                                                        </span> */}
                                                                        <span className="ms-2">{data?.tutor_name}</span>
                                                                    </div>
                                                                </td>
                                                                <td>{data?.formated_start_date}</td>
                                                                <td>{data?.timeslots?.formated_start_time} - {data?.timeslots?.formated_end_time}</td>
                                                                <td>
                                                                    <div>
                                                                        <span className="ms-2">
                                                                            <Link to={data?.teaching_type == '1' ? `/student/group-course-details/${btoa(data?.booking_id)}` : `/student/one-to-one-course-details/${btoa(data?.booking_id)}`}>
                                                                                <button
                                                                                    className="view-link btn p-0"
                                                                                // data-bs-toggle="modal"
                                                                                // data-bs-target="#bookingModal"
                                                                                >
                                                                                    <i
                                                                                        className="fa-solid fa-eye"
                                                                                        data-toggle="tooltip"
                                                                                        title="view schedule"
                                                                                    />
                                                                                </button>
                                                                            </Link>
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ))
                                                        :
                                                        <tr>
                                                            <td></td>
                                                            <td></td>
                                                            <td>No Data</td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                    }
                                                </tbody>


                                            </table>
                                        </div>}
                                </div>
                                {pageCount > 1 && (
                                    <ResponsivePagination
                                        pageCount={pageCount}
                                        currentPage={currentPage}
                                        handlePageClick={handlePageClick}
                                    />
                                )}
                            </main>

                        </div>
                    </div>

                </div>
            </section>
            <>
                {/* Booking View Modal */}
                <div
                    className="modal fade"
                    id="bookingModal"
                    tabIndex={-1}
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    Booking
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <h6 className="text-primary">Start Date: 3-11-2024</h6>
                                <h6 className="text-primary">Time Slot: 14:00PM - 15PM</h6>
                                <h6 className="text-primary">Topic Details: Chapter 1</h6>
                            </div>
                            <div className="modal-footer d-flex justify-content-start">
                                {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                <button type="button" className="btn btn-primary">
                                    Join Meeting
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default StudentBooking